module.exports = __webpack_public_path__ + "img/2025-12-20b_1.5042b03d.jpg";